import React from "react";
import HeaderDocument from "./HeaderDocument";
import VideoPlaceholder from "../../assets/images/video-placeholder.jpg";
import Layout from "../Layout";

const Documents = () => (
  <Layout>
    <HeaderDocument />
    {/*List of documents*/}
    <section className="layout-container">
      <div className="container">
        <div className="left-panel-s1" aria-labelledby="Left Panel List of Documents" >
          <div className="form-title g-clr">API</div>
          <ul className="spacer-margin4 indent-r">
            <li>
              <a href="https://svr-registration.directaddress.net/RA_v2/Help" target="_blank" rel="noreferrer" >
                Registration API v2 Endpoint
              </a>
            </li>
            {/*<li><a href="https://registration.directaddress.net/RA_v2/help" target="_blank">Registration API v2 Endpoint</a></li>*/}
            <li>
              <a href="https://s3.amazonaws.com/sesportalresources/Registration_API_v2.pdf" target="_blank" rel="noreferrer" >
                Registration API v2 Documentation (pdf)
              </a>
            </li>
            <li>
              <a href="https://s3.amazonaws.com/sesportalresources/SES_Reporting_API_v1.pdf" target="_blank" rel="noreferrer" >
                Reporting API v1 Documentation (pdf)
              </a>
            </li>
            <li>
              <a href="https://sesportalresources.s3.amazonaws.com/SES+Connect+v2.5+Web+Service+API.pdf" target="_blank" rel="noreferrer" >
                SES Connect v2 5 Web Service API (pdf)
              </a>
            </li>
            <li>
              <a href="https://s3.amazonaws.com/sesportalresources/RegAPI-Client-master.zip" >
                Registration API v2 Sample Code (zip)
              </a>
            </li>
            <li>
              <a href="https://s3.amazonaws.com/sesportalresources/TranportSecurityClientSampleCode.zip">
                Transport Security Client SampleCode (zip)
              </a>
            </li>
          </ul>
        </div>
        <div className="right-panel-s1" aria-labelledby="Right Panel Videos">
          <div className="form-title g-clr">Media</div>
          <div className="spacer-margin4">
            <aside>
              <img src={ VideoPlaceholder } className="w-full" alt="Video Placeholder" />
            </aside>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default Documents;
